import {
  ChangeDetectorRef,
  Component,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItemIcon } from '@angular/material/list';
import { BeforeInstallPromptEvent } from '../before-install-prompt-event';

@Component({
  selector: 'app-install-pwa',
  imports: [MatButton, MatIcon, MatListItemIcon],
  templateUrl: './install-pwa.component.html',
  styleUrl: './install-pwa.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '(window:beforeinstallprompt)': 'onBeforeInstallPrompt($event)',
    '(window:appinstalled)': 'appInstalled()',
  },
})
export class InstallPwaComponent {
  promptEvent?: BeforeInstallPromptEvent;

  private readonly cdr = inject(ChangeDetectorRef);

  onBeforeInstallPrompt(event: Event): void {
    event.preventDefault();
    this.promptEvent = event as BeforeInstallPromptEvent;
  }

  appInstalled(): void {
    // Needed as otherwise install btn is still visible after installation
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  public installPWA(): void {
    this.promptEvent?.prompt();
  }

  public shouldInstall(): boolean {
    return !this.isRunningInPWA() && !!this.promptEvent;
  }

  private isRunningInPWA(): boolean {
    return ['fullscreen', 'standalone', 'minimal-ui'].some(
      (displayMode) =>
        window.matchMedia('(display-mode: ' + displayMode + ')').matches,
    );
  }
}
